"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stepperNavigationStyles = void 0;
const lit_1 = require("lit");
exports.stepperNavigationStyles = (0, lit_1.css) ``;
